import { useState, useRef } from "react";
import type { FC, ReactNode } from "react";
import { MobileNavigationHeader } from "./MobileNavigationHeader/MobileNavigationHeader";
import {
  StyledWrapper,
  Tab,
  TabNavigation,
  Pointer,
  MessagingMenuWrapper,
  MessagingMenuSettingsWrapper,
} from "./styled";
import "@nectary/assets/icons/close";

type Tabs = "messaging" | "settings";
type MobileNavigationOpenProps = {
  onClose: () => void;
  messageItems: ReactNode;
  settingsItems: ReactNode;
  MobileProfileItem: FC<{ onClose: () => void }>;
};
export const MobileNavigationOpen: FC<MobileNavigationOpenProps> = ({
  onClose,
  messageItems,
  settingsItems,
  MobileProfileItem,
}) => {
  const [menuPage, setMenuPage] = useState<Tabs>("messaging");
  const [pointerPosition, setPointerPosition] = useState(8);
  const ref = useRef<null | HTMLDivElement>(null);

  const changePage = (page: Tabs) => {
    setMenuPage(page);
    if (ref.current) {
      switch (page) {
        case "messaging":
          return setPointerPosition(8);
        case "settings":
          return setPointerPosition(ref.current.offsetWidth + 8);
      }
    }
  };

  return (
    <StyledWrapper>
      <MobileNavigationHeader onClick={onClose}>
        <sinch-icon-close
          style={{
            fontSize: "32px",
            color: "#000",
          }}
        />
      </MobileNavigationHeader>
      <TabNavigation>
        <Tab
          onClick={() => changePage("messaging")}
          selected={menuPage === "messaging"}
        >
          Messaging
        </Tab>
        <Tab
          onClick={() => changePage("settings")}
          selected={menuPage === "settings"}
        >
          Settings
        </Tab>
        <Pointer left={pointerPosition} ref={ref} />
      </TabNavigation>
      {menuPage === "messaging" && (
        <MessagingMenuWrapper>{messageItems}</MessagingMenuWrapper>
      )}
      {menuPage === "settings" && (
        <MessagingMenuSettingsWrapper>
          <div>{settingsItems}</div>
          <MobileProfileItem onClose={onClose} />
        </MessagingMenuSettingsWrapper>
      )}
    </StyledWrapper>
  );
};
